import { useEffect, useState } from 'react';

import { v4 as uuid } from 'uuid';

import { getPlaceDetails, getProvidersInRange } from '../data-access/data-access';
import { FuneralHome } from '../static/models/FuneralHome';
import { SearchLocation } from '../static/models/SearchLocation';
import Settings from '../static/models/Settings';

interface ReturnType {
    locations: FuneralHome[];
    isLoading: boolean;
    searchLocation: SearchLocation | null;
}
export function useProviderSearch(search: string, settings: Settings): ReturnType {
    const [sessionToken] = useState(uuid()); // create a session ID and never update it for this use of useLocationAutocomplete
    const [locations, setLocations] = useState<FuneralHome[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchLocation, setSearchLocation] = useState<SearchLocation | null>(null);

    useEffect(() => {
        if (!search || search.length === 0) {
            setLocations([]);
            setIsLoading(false);
            setSearchLocation(null);
        } else {
            setIsLoading(true);
            const fetchProviderLocations = async () => {
                try {
                    const location = await getPlaceDetails(settings.googleMapsUri, sessionToken, '', search);
                    setSearchLocation(location);
                    if (location && location.latitude && location.longitude) {
                        const funeralHomes = await getProvidersInRange(
                            settings.efuneralGatewayBaseUrl,
                            settings.efuneralGatewayKey,
                            location.latitude,
                            location.longitude,
                        );
                        setLocations(funeralHomes);
                    }
                } catch (e) {
                    console.error(e);
                }
                setIsLoading(false);
            };

            fetchProviderLocations();
        }
    }, [search, sessionToken, settings]);

    return { locations, isLoading, searchLocation };
}
